import { render, staticRenderFns } from "./StudioApiPlayground.vue?vue&type=template&id=7f01a3bf&scoped=true"
import script from "./StudioApiPlayground.vue?vue&type=script&lang=js"
export * from "./StudioApiPlayground.vue?vue&type=script&lang=js"
import style0 from "./StudioApiPlayground.vue?vue&type=style&index=0&id=7f01a3bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f01a3bf",
  null
  
)

export default component.exports